import React from 'react'
import { Typography } from '@mui/material'
import styles from './budgetCard.module.scss'

const BudgetCard = ({ heading, children, style }) => {
	return (
		<div className={styles.budgetCard} style={style}>
			{heading && (
				<Typography variant="h3" className={styles.cardTitle}>
					{heading}
				</Typography>
			)}
			<div className={styles.cardBody}>{children}</div>
		</div>
	)
}

export default BudgetCard
